import { useEffect, useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { apiEditPltCommon } from "../../../api/master";
import uomSchema from "../../../validations/UOM";

function UOMEdit(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const uomFormik = useFormik({
    initialValues: {
      ptl_id: props.id?.ptl_id,
      uom_name: props.id?.plt_val || "",
    },
    validationSchema: uomSchema.validateUOM(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      const payload = {
        ptl_id: values.ptl_id,
        uom_name: values.uom_name,
      };
      await apiEditPltCommon(payload)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
          setTimeout(() => {
             props.hide();
          }, 1500);
        })
        .catch((err) => {
          setError(err.response?.data?.data?.message || err.message);
          setSuccess("");
        })
        .finally(() => {
          setIsSubmit(false);
        });
    },
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccess("");
      setError("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit UOM
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={uomFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-12">
            <label htmlFor="uom_name">
              UOM Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="uom_name"
              {...uomFormik.getFieldProps("uom_name")}
            />
            {uomFormik.errors.uom_name && (
              <div className="text-danger small">{uomFormik.errors.uom_name}</div>
            )}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="reset"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmit}
                className="btn btn-primary"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                  marginLeft: "10px",
                  background: "#4263eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "0 20px",
                }}
              >
                {isSubmit && (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                )}
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default UOMEdit;
